import styled, { css } from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';

export const DetailsRow = styled(Row)`
  margin-top: 15px;
`;

const HeaderCommon = css`
  position: relative;
  margin: 0;
  margin-bottom: 2px;
`;

export const PrimaryLabel = styled('h3')`
  ${HeaderCommon};
  ${(props) => props.theme.typography.heroStrong}
  color: ${(props) => props.theme.color.white};
`;

export const SecondaryLabel = styled('h3')`
  ${HeaderCommon};
  ${(props) => props.theme.typography.largeStrong}
  color: ${(props) => props.theme.color.white};
`;

const LabelCommon = css`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.7)};
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
`;

export const Label = styled('span')`
  ${LabelCommon}
`;

export const OverLabel = styled('span')`
  position: absolute;
  top: -14px;
  left: 0;
  ${(props) => props.theme.typography.tiny}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
`;

export const Question = styled('p')`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0;
  margin-top: 25px;
`;

export const Link = styled(RouterLink)`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.brand01};
`;

export const TipContainer = styled('span')`
  display: block;
  max-width: 210px;
`;
